import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { ControlButton } from 'console/shared/components/buttons/control';
import { useCustomControl } from '../../../../custom-controls/custom-controls-card/provider';
import { useDeviceState } from 'console/shared/contexts/device/state';
import { noop } from 'ts-essentials';
import { useDispatch } from 'react-redux';
import { useAnchor } from 'shared/hooks/utils';
import { VehicleControlButton } from 'shared/components/panels/vehicle-panel/components/controls/button';
import { CustomControlMenu } from 'shared/components/panels/vehicle-panel/components/custom-controls/button/custom-control-menu';
export const VehicleCustomControlButton = memo(function VehicleCustomControlButton() {
    const { sendCustomCommand, is_active, action_label, current_label, loading, fail, additional_commands, } = useCustomControl();
    const [anchor, openMenu, closeMenu] = useAnchor();
    const [showed_menu_count, setShowedMenuCount] = useState(0);
    const { online } = useDeviceState();
    const dispatch = useDispatch();
    const onButtonClick = useCallback(() => {
        if (sendCustomCommand) {
            return dispatch(sendCustomCommand());
        }
        return noop();
    }, [sendCustomCommand]);
    if (additional_commands && additional_commands.length > 1) {
        return (_jsx(VehicleControlButton, { label: current_label || action_label, openMenu: openMenu, showed_menu_count: showed_menu_count, is_custom: true, onClickCustomButton: onButtonClick, menu: _jsx(CustomControlMenu, { onClose: closeMenu, anchor: anchor, setMenuItemCount: setShowedMenuCount, additional_commands: additional_commands }) }));
    }
    return (_jsx(ControlButton, { onClick: onButtonClick, active: is_active ?? false, disabled: !online, fail: fail, loading: loading, style: { cursor: sendCustomCommand ? 'pointer' : 'default' }, children: current_label || action_label }));
});
